import { fetchMonitorUsers, fetchStatus } from "@/app/supervision/services";
import { SET_MONITOR_USERS } from "./mutation-types";

let currentRequest = 0;

const actions = {
  async fetchMonitorUsers({ commit }, filters) {
    const requestId = ++currentRequest;
    const users = await fetchMonitorUsers(filters);
    // Solo hacer commit si esta sigue siendo la petición más reciente
    if (requestId === currentRequest) {
      commit(SET_MONITOR_USERS, users);
    }
  },
  async fetchStatusMonitoring() {
    return fetchStatus();
  },
};

export default actions;
